import React from "react";
import { MdPhotoLibrary } from "react-icons/md";
import Link from "next/link";
import styles from "./news_image_card.module.scss";
import { excerpt, getAssets } from "@unisearch/helpers";

/* 
For Custom Classes Props it takes
customClasses={
  cardClass:styles.[your custom class name],
  headClass: styles.[your custom class name],
  bodyClass: styles.[your custom class name],
  featureImageClass: styles.[your custom class name],
  titleClass: styles.[your custom class name],
  dateClass: styles.[your custom class name],
  imageIconClass: styles.[your custom class name],
  overlayClass: styles.[your custom class name],
}
*/

export const NewsImageCard = ({
  data,
  customClasses,
  showDescription = false,
  showDate = false,
  overlay = false,
  ...props
}) => {
  return (
    <div
      className={`${styles.image_card} ${
        customClasses?.cardClass ? customClasses?.cardClass : ""
      }`}
    >
      <div
        className={`${styles.image_card_head} ${
          customClasses?.headClass ? customClasses?.headClass : ""
        }`}
      >
        <Link legacyBehavior href={`/news/gallery/${data?.slug}`}>
          <a
            className={`${styles.image_card_image_wrapper} ${
              customClasses?.featureImageClass
                ? customClasses?.featureImageClass
                : ""
            }`}
          >
            <div
              className={`${styles.image_card_image_icon} ${
                customClasses?.imageIconClass
                  ? customClasses?.imageIconClass
                  : ""
              }`}
            >
              <MdPhotoLibrary />
            </div>
            {overlay && (
              <div
                className={`${styles.image_card_overlay} ${
                  customClasses?.overlayClass ? customClasses?.overlayClass : ""
                }`}
              ></div>
            )}
            <img
              src={
                data?.featureImage?.src ||
                getAssets("assets/images/image_placeholder_big.webp")
              }
              alt={data?.featureImage?.src || "Featured Image"}
            />
          </a>
        </Link>
      </div>
      <div
        className={`${
          customClasses?.bodyClass ? customClasses?.bodyClass : ""
        }`}
      >
        <Link legacyBehavior href={`/news/gallery/${data?.slug}`}>
          <a
            className={`${styles.image_card_title} ${
              customClasses?.titleClass ? customClasses?.titleClass : ""
            }`}
          >
            {data?.newsTitle}
          </a>
        </Link>

        {showDate && (
          <div
            className={`${styles.image_card_date} ${
              customClasses?.dateClass ? customClasses?.dateClass : ""
            }`}
          >
            MyUniseach - December 10, 2019
          </div>
        )}

        {showDescription && (
          <div className={styles.image_card_description}>
            {data?.shortDescription
              ? excerpt(data.shortDescription, 200)
              : data?.newsContent
              ? excerpt(data?.newsContent, 200)
              : ""}
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsImageCard;
